export const IFRAME_BASE_PATH = '/iframe';

export const isIframePath = (pathname: string) =>
  pathname === IFRAME_BASE_PATH || !!pathname?.startsWith(`${IFRAME_BASE_PATH}/`);
